/**
 *
 *  ContentScrollerBaseScroller
 *  Component
 *
 *
 *  Created by Vladimir Shishlyannikov on 25/02/2023.
 *  Copyright (c) 2016-present iWoo Ltd. All rights reserved.
 *
 */

import React from "react";

const ContentScrollerBaseScroller = React.forwardRef(
  ({ children, className, style, ...rest }, outerRef) => {
    return (
      <div
        className="content-scroller-base-scroller"
        ref={outerRef}
        style={style}
        {...rest}
      >
        {children}
      </div>
    );
  }
);

export default ContentScrollerBaseScroller;
